/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Board_TitleInputs */

const en_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board Response Rates`)
};

const de_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antwortquoten nach Jobbörse`)
};

const fr_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taux de réponse par site`)
};

const es_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasas de respuesta por portal`)
};

const it_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tassi di risposta per piattaforma`)
};

const nl_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responspercentages per platform`)
};

const pl_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wskaźniki odpowiedzi portali`)
};

const fi_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sivuston vastausprosentit`)
};

const da_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portalens svarprocenter`)
};

const sv_analytics_board_title = /** @type {(inputs: Analytics_Board_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portalens svarsfrekvenser`)
};

/**
* | output |
* | --- |
* | "Board Response Rates" |
*
* @param {Analytics_Board_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_board_title = /** @type {((inputs?: Analytics_Board_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Board_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_board_title(inputs)
	if (locale === "fr") return fr_analytics_board_title(inputs)
	if (locale === "es") return es_analytics_board_title(inputs)
	if (locale === "it") return it_analytics_board_title(inputs)
	if (locale === "nl") return nl_analytics_board_title(inputs)
	if (locale === "pl") return pl_analytics_board_title(inputs)
	if (locale === "fi") return fi_analytics_board_title(inputs)
	if (locale === "da") return da_analytics_board_title(inputs)
	if (locale === "sv") return sv_analytics_board_title(inputs)
	return en_analytics_board_title(inputs)
});